'use strict';

const OriginalContentItemView = require('data/ui/view/content/item');
const ContentListView = require('data/ui/view/content/list');
const ItemViewTemplate = require('balus/ui/template/body/process/toolbar/content-item.hbs');

const ContentItemView = OriginalContentItemView.extend({
    template: ItemViewTemplate,
    showItemLink: false,
    showOpenURI: false,
    className: function() {
        if (this._isAlreadyPresent) {
            return "list-item is-deactivated";
        } else {
            return 'list-item'
        }
    },
    events: {
        'change': 'select'
    },

    initialize: function() {
        // データ追加のリスト表示時に、既に追加済みのものについては、 is-deactivate クラスを付与する
        this._isAlreadyPresent = false;
        const presentContents = this.getOption('presentContents');
        if (presentContents) {
            this._isAlreadyPresent = !!_.find(presentContents, (content) => {
                return content.id === this.model.id;
            });
        }
    },

    templateContext: function() {
        return {
            checked: this._isAlreadyPresent,
            disabled: this._isAlreadyPresent,
        };
    },

    onAttach: function() {
        $.material.init();
    },

    select: function() {
        this.$el.toggleClass('is-active');
        if(this.$el.hasClass('is-active')) {
            this.triggerMethod('active', this.model);
        } else {
            this.triggerMethod('inactive', this.model);
        }
    }
});

module.exports = ContentListView.extend({
    childView: ContentItemView,

    childViewOptions: function() {
        return {
            presentContents: this.getOption('presentContents'),
        };
    },

    onChildviewActive: function(content) {
        if(!this._activeContents) {
            this._activeContents = {};
        }
        this._activeContents[content.id] = content;
        this.trigger('select:content');
    },

    onChildviewInactive: function(content) {
        delete this._activeContents[content.id];
        this.trigger('select:content');
    },

    getActiveContents: function() {
        return _.keys(this._activeContents);
    },
    resetActiveContents: function() {
        this._activeContents = [];
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/toolbar/content-list.js